import axios from 'axios';
import { message, Page, Text, Select } from 'components';
import React from 'react';
import styled from 'styled-components';
import RemindAndRemoveSubscriptions from './SupraCronJobs/RemindAndRemoveSubscriptions';
import SyncSupraLockboxActivities from './SupraCronJobs/SyncSupraLockboxActivities';
import LockboxImportKdps from './SupraCronJobs/LockboxImportKdps';

enum CronNames {
  LOCKBOX_IMPORT_KDPS = 'lockboxImportKdps',
  REMIND_AND_REMOVE_SUBSCRIPTIONS = 'remindAndRemoveExpiredSupraSubscriptions',
  SYNC_SUPRA_LOCKBOX_ACTIVITIES = 'syncSupraLockboxActivities',
}

const getC = (
  c: `${CronNames}`,
): React.FC<{ fire: (payload: any) => Promise<void> }> => {
  switch (c) {
    case 'lockboxImportKdps':
      return LockboxImportKdps;
    case 'remindAndRemoveExpiredSupraSubscriptions':
      return RemindAndRemoveSubscriptions;
    case 'syncSupraLockboxActivities':
      return SyncSupraLockboxActivities;

    default:
      return RemindAndRemoveSubscriptions;
  }
};

const SupraCronjobs = () => {
  const [cronType, setCronType] = React.useState<`${CronNames}`>(
    'remindAndRemoveExpiredSupraSubscriptions',
  );
  const [isLoading, setIsLoading] = React.useState(false);

  const fire = async (payload: any) => {
    try {
      if (isLoading) return;
      setIsLoading(true);
      const response = await axios.post(`/supra/qa_pages/${cronType}`, {
        data: payload,
      });
      if (response.data?.message) {
        message.success(response.data.message);
      } else {
        message.success(`Cron job: ${cronType} was triggered`);
      }
    } catch (error) {
      message.error(error?.toString(), 8);
    } finally {
      setIsLoading(false);
    }
  };

  const Form = getC(cronType);

  return (
    <Page type="filled" title="Supra System Cronjobs QA Page" fillScreenHeight>
      <Layout>
        <Text>
          This QA page is used to manually fire cron jobs related to supra
          system
        </Text>
        <StyledSelect
          value={cronType}
          onChange={value => setCronType(value)}
          options={Object.values(CronNames).map(v => ({
            label: v,
            value: v,
          }))}
          label="Cron Name"
        />
        <Form fire={fire} />
      </Layout>
    </Page>
  );
};

export default SupraCronjobs;

const Layout = styled.div`
  display: flex;
  flex-flow: column nowrap;
  gap: 10px;
  padding: 20px;
  background: white;
`;

const StyledSelect = styled(Select)`
  width: 500px;
`;

const StyledText = styled(Text)`
  line-height: 2;
`;
